module.exports = __webpack_public_path__ + "img/icon_weather_117.18233089.svg";